import { AppIcon, lottieAnimations, ICON_SIZES } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Button, SxProps, Theme } from '@mui/material';
import Lottie from 'lottie-react';

const MOBILE_VIEW_TOGGLE_LABELS = appStrings.modules.mobileViewToggle;

type MobileViewToggleProps = Readonly<{
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  type: 'CHAT' | 'RECS';
}>;

export const MobileViewToggle = ({ onClick, type, loading, disabled }: MobileViewToggleProps) => {
  return (
    <Box sx={toggleButtonContainer}>
      <Button
        id="lubav-mobile-view-toggle"
        onClick={onClick}
        hierarchy="Secondary gray"
        size="sm"
        sx={toggleMobileViewSx}
        disabled={disabled}
      >
        {loading ? (
          <Box sx={loadingContainerSx}>
            <Lottie animationData={lottieAnimations.dotsDotting} loop />
          </Box>
        ) : (
          <AppIcon
            iconName="SwitchVertical01"
            diameter="20px"
            color={disabled ? 'Gray/300' : 'Gray/700'}
            strokeWidth="bold"
          />
        )}
        {type === 'CHAT' ? MOBILE_VIEW_TOGGLE_LABELS.recs : MOBILE_VIEW_TOGGLE_LABELS.lubav}
      </Button>
    </Box>
  );
};

const toggleButtonContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
};

const toggleMobileViewSx: SxProps<Theme> = {
  width: 'fit-content',
  textTransform: 'none',
  color: 'Gray/700',
  '&:hover': {
    backgroundColor: 'transparent',
    '& .MuiTypography-root': {
      color: 'Gray/400',
    },
  },
};

const loadingContainerSx: SxProps<Theme> = {
  width: ICON_SIZES['20px'],
  height: ICON_SIZES['20px'],
};
